import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

/**
 * Holiday regions are derived from the existing holiday calendars, so this only ever
 * returns regions that already have at least one calendar. New regions come into
 * existence by creating a calendar for them.
 */
const getHolidayRegionListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.holidayCalendar.regions();
		const content = res.map(({ region, regionCode, ...o }) => ({ label: region || regionCode, value: regionCode, ...o }));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getHolidayRegionListing;
